// extracted by mini-css-extract-plugin
module.exports = {"container":"DevTools_container__3sHwG","info":"DevTools_info__2mlQv","languageSelection":"DevTools_languageSelection__o8Ip4"};